/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./view-dialog.vue?vue&type=template&id=d8959a12&scoped=true&"
import script from "./view-dialog.vue?vue&type=script&lang=ts&"
export * from "./view-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./view-dialog.vue?vue&type=style&index=0&id=d8959a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8959a12",
  null
  
)

export default component.exports